import React from 'react';
import PropTypes from 'prop-types';
import { withFormsy } from 'formsy-react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Select.css';

class Select extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      selectTitle: '',
      canDisplayError: false,
    };
    this.changeValue = this.changeValue.bind(this);
    this.displayError = this.displayError.bind(this);
  }

  componentDidMount() {
    if (this.props.defaultValue) {
      this.props.setValue(this.props.defaultValue);
    }
    this.isFirefox = window.navigator.userAgent.toLowerCase().indexOf('firefox') > -1; // tmp
  }

  componentWillReceiveProps(nextProps) {
    if (!this.state.selectTitle && nextProps.defaultValue) {
      this.props.setValue(nextProps.defaultValue);
    }
  }

  getTitle() {
    let title = null;

    if (this.props.defaultValue && this.props.options.length) {
      const defaultOption = this.props.options.find(option => option.value === this.props.defaultValue);
      title = defaultOption ? defaultOption.title : title;
    }
    title=null;
    return title || this.props.title || this.props.options[0].title;
  }

  changeValue(event) {
    const options = event.currentTarget.options;
    let values = [];
    for (let i = 0, l = options.length; i < l; i = i + 1) {
      if (options[i].selected) {
        values.push(options[i].value);
      }
    }
    if (this.props.onChange) {
      this.props.onChange(values);
    }
  }

  keyDown(event) {
    if (event.keyCode === 40 || event.keyCode === 38) {
      setTimeout(() => {
        this.refs.select.blur();
        this.refs.select.focus();
      }, 0);
    }
  }

  displayError() {
    this.setState({
      canDisplayError: true,
    });
  }

  render() {
    let className = 'FormSelect';
    if (this.props.showRequired()) {
      className = classNames(s.required, s[className]);
    } else if (this.props.showError()) {
      className = classNames(s.error, s[className]);
    }
    const errorMessage = 
      this.props.getErrorMessage() || (this.props.showRequired() && this.props.isFormSubmitted() ? 'field_required' : null);

    const options = this.props.options.map((option) => (
      <option key={option.title + option.value} value={option.value}>
        {option.title}
      </option>
    ));

    const selectTitle = this.state.selectTitle
      ? this.state.selectTitle
      : this.getTitle();

    const selectClassNames = classNames(s.Form_field, s.big);

    const labelClassNames = this.props.titleVisibility
      ? classNames(s.FormSelect__label)
      : classNames(s.FormSelect__label, s.u_hidden);
    return (
      <div className={className}>
        <label htmlFor={this.props.name} className={labelClassNames}>
          {this.props.title}
        </label>
        <div className="u-posRelative">
          {selectTitle !== this.props.title ? (
            <select
              ref="select"
              multiple={this.props.multiple}
              className={selectClassNames}
              name={this.props.name}
              disabled = {this.props.disabled ? 'disabled' : null}
              onChange={this.changeValue}
              onKeyDown={this.isFirefox ? this.keyDown : null}
              onBlur={this.displayError}
              value={this.props.getValue()}>
                {options}
            </select>) : (
             <select
              ref="select"
              multiple={this.props.multiple}
              className={selectClassNames}
              name={this.props.name}
              disabled = {this.props.disabled ? 'disabled' : null}
              onChange={this.changeValue}
              onKeyDown={this.isFirefox ? this.keyDown : null}
              onBlur={this.displayError}
              value={this.props.getValue()}>
                <option key={`$selectTitle.title`} className={s.u_hidden}> {selectTitle} </option>
                {options}
            </select>)}
        </div>

        {(this.props.isFormSubmitted()) && errorMessage ? (<div className="Form-error"><FormattedMessage id={errorMessage} /></div>) : null}
      </div>
    );
  }
};

Select.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  titleVisibility: PropTypes.bool,
  disabled: PropTypes.bool,
  defaultValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  autofocus: PropTypes.bool,
  className: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  large: PropTypes.bool,
  withoutBorder: PropTypes.bool,
  multiple: PropTypes.bool,
  onChange: PropTypes.func,
};

Select.defaultProps = {
  large: false,
  multiple: false,
  withoutBorder: false,
  titleVisibility: false,
};

export default withFormsy(withStyles(s)(Select));


// WEBPACK FOOTER //
// ./src/components/SelectMultiple/Select.js